"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
import { IconChevronDown } from "../internal/icons.js";
/** Short status label: icon + 1–2 words on a soft tone. With `onClick` it is a button (menu of statuses). */
export function Badge({ tone = "neutral", icon, children, title, tip, onClick, pressed, caret, mark, dot, className }) {
    const classes = cx("jui-badge", `jui-tone-${tone}`, caret && "jui-badge--caret", dot && "jui-badge--dot", className);
    const body = _jsxs(_Fragment, { children: [icon, children, mark && _jsx("span", { className: "jui-badge-mark", children: mark }), caret && _jsx(IconChevronDown, { small: true, className: "jui-badge-caret" })] });
    if (onClick)
        return _jsx("button", { type: "button", className: classes, title: title ?? tip, "aria-pressed": pressed, "aria-haspopup": caret ? "menu" : undefined, onClick: onClick, children: body });
    return _jsx("span", { className: classes, title: title ?? tip, children: body });
}
/**
 * Material 3 badge (large: a number; `small`: a dot). A number: list sizes next to titles (neutral), alerts on tabs (strong + error), filters in use (strong + accent).
 * Shows `max+` above `max`. With `onClick` it is a button.
 */
export function Counter({ value, tone = "neutral", strong = false, max = 99, label, icon, small, onClick, className }) {
    const text = value > max ? `${max}+` : String(value);
    const classes = cx("jui-counter", strong && "jui-counter--strong", !!icon && "jui-counter--icon", small && "jui-counter--small", `jui-tone-${tone}`, className);
    if (small)
        return _jsx("span", { className: classes, role: "status", "aria-label": label ? `${label}: ${text}` : text, title: label });
    if (onClick)
        return _jsxs("button", { type: "button", className: classes, "aria-label": label ? `${label}: ${text}` : undefined, title: label, onClick: onClick, children: [icon, text] });
    return _jsxs("span", { className: classes, "aria-label": label, role: label ? "status" : undefined, children: [icon, text] });
}
